module.exports = __webpack_public_path__ + "static/media/Axis_Mutual_Fund.2ff042dd.pdf";